export default function NoContentAvailable() {
  return (
    <>
      <p className="SRC-no-results-title">
        There is currently no content here.
      </p>
      <p className="SRC-no-results-description">
        Information is always being updated, so check back later to see if
        content has been added.
      </p>
    </>
  )
}
